import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { Breakpoints } from "@pb/utils/constants/breakpoints";
import { default as consoleEvents } from "@pb/utils/consoleEvents";
import { default as useMediaQuery } from "@pb/utils/reactHooks/useMediaQuery";
import { default as getQuickShopProduct } from "@pb/utils/getQuickShopProduct";
import Modal from "../../../../../ui/Modal";
import styles from './QuickShopModal.module.scss';
import ArketTemplate from './templates/ArketTemplate';
import CosTemplate from './templates/CosTemplate';
import MonkiTemplate from './templates/MonkiTemplate';
import StoriesTemplate from './templates/StoriesTemplate';
const QuickShopModal = ({ pralocale, articleId, baseUrl, shouldLoad, shouldOpen = false, brand, onClose, isLoaded, quickBuyLink = '', }) => {
    var _a;
    const [QSProduct, setQSProduct] = useState(null);
    const [isQSPLoading, setQSPLoading] = useState(true);
    const [hasQSPLoaded, setQSPLoaded] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const articleCodes = articleId ? [articleId] : [];
    const isMobile = useMediaQuery(Breakpoints.MEDIUM);
    const brandWithFallback = brand || (baseUrl && ((_a = baseUrl.match(/(?<=www\.)[^.]+(?=\.com)/)) === null || _a === void 0 ? void 0 : _a[0])) || '';
    const brandTemplateMap = {
        arket: ArketTemplate,
        cos: CosTemplate,
        monki: MonkiTemplate,
        otherStories: StoriesTemplate,
        stories: StoriesTemplate,
    };
    const mapQSPLocale = (locale) => {
        if (locale !== 'en_eur') {
            return locale;
        }
        const newPraLocale = window.location.pathname.split('/')[1];
        return newPraLocale;
    };
    const quickShopProduct = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const response = yield getQuickShopProduct({
                articleCodes,
                locale: mapQSPLocale(pralocale) || '',
                apiBaseUrl: baseUrl || '',
                quickBuyLink,
            });
            if (response) {
                setQSProduct(response);
                setQSPLoading(false);
                setQSPLoaded(true);
            }
            else {
                setQSPLoading(false);
                setQSPLoaded(false);
            }
        }
        catch (error) {
            setQSPLoading(false);
            consoleEvents.error("Couldn't fetch data from QuickShop API", error);
        }
    });
    const toggleModal = (open) => {
        setIsModalOpen(true);
        if (!open) {
            setIsModalOpen(false);
        }
    };
    const handleAddToCart = () => {
        toggleModal(false);
        // Below tracking will be enabled once Matching set is ready to use and deployed to production
        // trackingQSP('addToCart', 'quickshop', 'button.quickshop.addtocart')
    };
    const handleCloseClick = () => {
        var _a;
        onClose();
        appeaser === null || appeaser === void 0 ? void 0 : appeaser.scan();
        appeaser === null || appeaser === void 0 ? void 0 : appeaser.unsubscribe((_a = appeaser === null || appeaser === void 0 ? void 0 : appeaser.Enums) === null || _a === void 0 ? void 0 : _a.listen.ON_ITEM_ADDED_TO_CART, () => toggleModal(false));
    };
    useEffect(() => {
        if (hasQSPLoaded) {
            isLoaded(true);
        }
        else {
            isLoaded(false);
        }
    }, [hasQSPLoaded]);
    useEffect(() => {
        if (shouldLoad) {
            setQSPLoading(true);
            quickShopProduct();
        }
    }, [shouldLoad]);
    useEffect(() => {
        if (shouldOpen) {
            setIsModalOpen(true);
        }
    }, [shouldOpen]);
    useEffect(() => {
        var _a, _b;
        if (isModalOpen) {
            appeaser === null || appeaser === void 0 ? void 0 : appeaser.scan();
            appeaser === null || appeaser === void 0 ? void 0 : appeaser.publish((_a = appeaser === null || appeaser === void 0 ? void 0 : appeaser.Enums) === null || _a === void 0 ? void 0 : _a.listen.ON_QUICKSHOP_LOADED);
            appeaser === null || appeaser === void 0 ? void 0 : appeaser.subscribe((_b = appeaser === null || appeaser === void 0 ? void 0 : appeaser.Enums) === null || _b === void 0 ? void 0 : _b.listen.ON_ITEM_ADDED_TO_CART, () => handleAddToCart());
        }
    }, [isModalOpen]);
    const ModalTemplate = brandTemplateMap[brandWithFallback];
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { isOpen: isModalOpen, closeButtonText: "close", toggleModal: toggleModal, modalType: "stickyRight", onClosing: handleCloseClick, style: { marginRight: 'auto !important' }, disableRemoveScroll: isMobile, innerContainerClassName: brandWithFallback === 'cos' ? styles.cosInnerContainer : '', closeButtonSize: "small", closeButtonClassName: brandWithFallback === 'cos' ? styles.cosCloseButton : '' },
            isQSPLoading && React.createElement("div", { className: "loading>" }, "Loading quick shop"),
            !isQSPLoading && isModalOpen && QSProduct !== null && (React.createElement(React.Fragment, null,
                React.createElement(ModalTemplate, { QSProduct: QSProduct, articleId: articleCodes }))))));
};
export default QuickShopModal;
//# sourceMappingURL=QuickShopModal.js.map